<template>
	<div id="charts-component">

		<top-bar></top-bar>

		<div class="row">
			<div class="col-sm-3">
				<tables-list :useCart="false"></tables-list>
			</div>
			<div class="col-sm-9">
				<ts-chart v-if="showGraph"></ts-chart>
				<spinner v-if="pending"></spinner>
			</div>
		</div>

	</div>
</template>


<script type="text/javascript">

import TablesList from './TableList.vue'
import TopBar from './TopBar.vue'
import TSChart from './TSChart.vue'
import Spinner from 'vue-spinner/src/RingLoader.vue'

export default {
	components: {
		'tables-list': TablesList,
		'top-bar': TopBar,
		'ts-chart': TSChart,
		'spinner': Spinner
	},
	computed: {
		pending() {
			return this.$store.state.basket.pending
		},
		showGraph() {
			return (
				this.$store.state.basket.loaded
				&& !this.$store.state.basket.pending
			)
		}
	}
}

</script>
